/* Equal tropical sectors, not houses. Leaders retain the exact longitude. */
(() => {
  'use strict';
  const NS='http://www.w3.org/2000/svg';
  function svgNode(name, attributes={}, text) {
    const node=document.createElementNS(NS,name);
    for (const [key,value] of Object.entries(attributes)) node.setAttribute(key,value);
    if (text !== undefined) node.textContent=text;
    return node;
  }
  const point=(angle,radius)=>[300+Math.sin(angle*Math.PI/180)*radius,300-Math.cos(angle*Math.PI/180)*radius];
  function wheel(placements, signs, labels, describe, preview) {
    const svg=svgNode('svg',{viewBox:'0 0 600 600',role:'img','aria-label':preview ? labels[preview.sign === undefined ? 'preview_wheel' : 'birthday_wheel'] : labels.wheel_title});
    svg.append(svgNode('title',{},preview ? labels.preview_title : labels.wheel_title),svgNode('desc',{},preview ? labels[preview.sign === undefined ? 'preview_note' : 'birthday_note'] : labels.wheel_desc));
    for (const radius of [255,240,184,preview ? 105 : 70]) svg.append(svgNode('circle',{cx:300,cy:300,r:radius,class:'mm-chart__ring'}));
    for(let i=0;i<12;i++) {
      const [x,y]=point(i*30,255),[x2,y2]=point(i*30,240),[tx,ty]=point(i*30+15,276);
      svg.append(svgNode('line',{x1:x,y1:y,x2,y2,class:'mm-chart__sector'}));
      svg.append(svgNode('text',{x:tx,y:ty,'text-anchor':'middle','dominant-baseline':'middle',class:'mm-chart__sign'},signs[i].slice(0,3)));
    }
    if (preview) {
      svg.dataset.previewWheel='';
      if (Number.isInteger(preview.sign)) {
        const a=preview.sign*30,b=a+30,[x,y]=point(a,240),[x2,y2]=point(b,240),[ix,iy]=point(b,184),[ix2,iy2]=point(a,184);
        const sector=svgNode('path',{d:`M ${x} ${y} A 240 240 0 0 1 ${x2} ${y2} L ${ix} ${iy} A 184 184 0 0 0 ${ix2} ${iy2} Z`,class:'mm-chart__sun-sector','data-preview-sign':preview.sign});
        sector.append(svgNode('title',{},`${labels.Sun}: ${signs[preview.sign]}`));svg.append(sector);
      }
      svg.append(svgNode('text',{x:300,y:290,'text-anchor':'middle',class:'mm-chart__preview-center'},Number.isInteger(preview.sign)?signs[preview.sign]:labels.preview_center),svgNode('text',{x:300,y:320,'text-anchor':'middle',class:'mm-chart__preview-sub'},Number.isInteger(preview.sign)?labels.Sun:labels.preview_center_sub));
      return svg;
    }
    if (!placements.length) return svg;
    // Unwrap at the largest empty arc. Space numbered labels while pointing to
    // their real positions on the inner ring, even for tightly clustered planets.
    const sorted=placements.map((p,i)=>({...p,index:i,angle:p.longitude})).sort((a,b)=>a.angle-b.angle);
    let cut=0,gap=-1;
    sorted.forEach((p,i)=>{const next=sorted[(i+1)%sorted.length].angle+(i===sorted.length-1?360:0);if(next-p.angle>gap){gap=next-p.angle;cut=(i+1)%sorted.length;}});
    const arranged=[...sorted.slice(cut),...sorted.slice(0,cut)];
    const start=arranged[0].angle;
    arranged.forEach((p,i)=>{p.labelAngle=p.angle<start?p.angle+360:p.angle;if(i)p.labelAngle=Math.max(p.labelAngle,arranged[i-1].labelAngle+17);});
    arranged[arranged.length-1].labelAngle=Math.min(arranged.at(-1).labelAngle,start+343);
    for(let i=arranged.length-2;i>=0;i--) arranged[i].labelAngle=Math.min(arranged[i].labelAngle,arranged[i+1].labelAngle-17);
    for(const p of arranged) {
      const [x,y]=point(p.angle,184),[tx,ty]=point(p.labelAngle,217);
      const g=svgNode('g',{'data-chart-marker':p.body});
      g.append(svgNode('title',{},`${labels[p.body]}: ${describe(p)}`),svgNode('line',{x1:x,y1:y,x2:tx,y2:ty,class:'mm-chart__leader'}),svgNode('circle',{cx:x,cy:y,r:3,class:'mm-chart__point'}),svgNode('circle',{cx:tx,cy:ty,r:12,class:'mm-chart__badge'}),svgNode('text',{x:tx,y:ty,'text-anchor':'middle','dominant-baseline':'central',class:'mm-chart__number'},String(p.index+1)));
      svg.append(g);
    }
    svg.append(svgNode('text',{x:300,y:300,'text-anchor':'middle','dominant-baseline':'central',class:'mm-chart__center','aria-hidden':'true'},'✧'));
    return svg;
  }
  window.MoonmeetChartWheel=wheel;
})();
